module.exports = __webpack_public_path__ + "static/img/2-3.91106f3a.png";